module.exports = __webpack_public_path__ + "static/1435198936.0cf2454c.jpg";